import {
  SALE_ORDER_ESIMQR,
  SALE_ORDER_ESIMQR_ERROR,
  CLEAN_SALE_ORDER_ESIMQR,
  CLEAN_SALE_ORDER_ESIMQR_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function saleOrderEsimQrReducer(state = initialState, action) {
  switch (action.type) {
    case SALE_ORDER_ESIMQR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case SALE_ORDER_ESIMQR_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_SALE_ORDER_ESIMQR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_SALE_ORDER_ESIMQR_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
